import React, { useState, useContext, useRef } from "react";
import { Switch, Route } from "react-router-dom";
import clsx from "clsx";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

import AppContext from "../appContext";
import UserTimeline from "../UserTimeline";
import UserBoards from "../UserBoards";
import UserSurveys from "../UserSurveys";
import ClientHeader from "./ClientHeader";
import useClasses from "../useClasses";
import Home from "../Home";

const drawerWidth = 300;

const styles = (theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up("md")]: {
      marginLeft: drawerWidth,
    },
  },
  xs: {
    padding: theme.spacing(1),
  },
  s: {
    padding: "12px",
  },
  m: {
    padding: theme.spacing(3),
  },
});

export default function User(props) {
  const classes = useClasses(styles);
  const {
    app: {
      client: { id: clientId },
      openClientDrawer: open,
    },
  } = useContext(AppContext);

  const listInnerRef = useRef();
  const [page, setPage] = useState(1);
  const handleClearPage = () => setPage(1);
  const onScroll = () => {
    if (props.match.path !== "/timeline") return; // don't implement infinite scroll for moodboards and surveys
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight + 10 >= scrollHeight) {
        // correction of 10
        setPage((prev) => prev + 1);
      }
    }
  };
  return (
    <Box
      className={clsx(classes.content, {
        [classes.contentShift]:
          open &&
          ["/timeline", "/moodboards", "/surveys", "/home"].includes(
            props.match.path
          ),
      })}
      key={clientId}
      ref={listInnerRef}
      onScroll={onScroll}
      sx={{ height: "100vh", overflowY: "auto" }}
    >
      {clientId !== -1 ? (
        <Switch>
          <Route
            path={"/home"}
            render={() => (
              <Container>
                <Home />
              </Container>
            )}
          />
          <Route
            path={"/timeline"}
            render={(props) => (
              <Container>
                <ClientHeader {...props} />
                <UserTimeline
                  page={page}
                  handleClearPage={handleClearPage}
                  {...props}
                />
              </Container>
            )}
          />
          <Route
            path={"/moodboards"}
            render={(props) => (
              <Container>
                <ClientHeader {...props} />
                <UserBoards {...props} />
              </Container>
            )}
          />
          <Route
            path={"/surveys"}
            render={(props) => (
              <Container>
                <ClientHeader {...props} />
                <UserSurveys {...props} />
              </Container>
            )}
          />
        </Switch>
      ) : (
        <Container>
          <Home />
        </Container>
      )}
    </Box>
  );
}
